class ImageBlockReveal extends HTMLElement {
  connectedCallback() {
    if (this.hasAttribute('is-visible')) return;
    if (!('IntersectionObserver' in window)) {
      this.setAttribute('is-visible', '');
      return;
    }

    this.#observer ??= new IntersectionObserver(
      (entries) => {
        const entry = entries[entries.length - 1];

        if (!entry?.isIntersecting) return;

        this.setAttribute('is-visible', '');
        this.#observer?.disconnect();
        this.#observer = null;
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -5% 0px',
      }
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  /** @type {IntersectionObserver | null} */
  #observer = null;
}

if (!customElements.get('image-block-reveal')) {
  customElements.define('image-block-reveal', ImageBlockReveal);
}
